module.exports = __webpack_public_path__ + "img/yousty.08b0b596.png";